import { createFileRoute } from '@tanstack/react-router'
import { StaffPemilihan } from '../../../../components/StaffPemilihan'

export const Route = createFileRoute('/platform/desa/$desaId/pemilihan')({
  component: () => {
    const { desaId } = Route.useParams()
    return <StaffPemilihan desaId={desaId} />
  },
})
